module.exports = __webpack_public_path__ + "media/images/athletes/3446-c209a0000becb1acf90fe769b56bcc10.png";